// Shared business matching utilities for both frontend and backend

function normalizeString(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function isFuzzyMatch(name1, name2) {
  if (!name1 || !name2) return false;
  
  const normalized1 = normalizeString(name1);
  const normalized2 = normalizeString(name2);
  
  // Exact match after normalization
  if (normalized1 === normalized2) return true;
  
  // Check if one normalized name is fully contained in the other
  // This handles cases like "lashspot" vs "lashspot sf"
  if (normalized1.length >= 5 && normalized2.length >= 5) {
    if (normalized1.startsWith(normalized2 + ' ') || normalized2.startsWith(normalized1 + ' ')) {
      return true;
    }
  }
  
  // Split into words for more sophisticated matching
  const words1 = normalized1.split(/\s+/).filter(word => word.length > 2);
  const words2 = normalized2.split(/\s+/).filter(word => word.length > 2);
  
  // Both names must have meaningful words
  if (words1.length === 0 || words2.length === 0) return false;
  
  // Don't match single-word names unless they're exactly the same (already handled above)
  if (words1.length === 1 || words2.length === 1) {
    return false;
  }
  
  // Check if one name fully contains the other (but only for multi-word names)
  // This helps match "Heytea Downtown" with "Heytea Downtown Metroen"
  if (words1.length >= 2 && words2.length >= 2) {
    const smaller = words1.length < words2.length ? words1 : words2;
    const larger = words1.length < words2.length ? words2 : words1;
    
    // Check if all words from smaller name appear in larger name in order
    let matchCount = 0;
    let lastIndex = -1;
    for (const word of smaller) {
      const index = larger.indexOf(word);
      if (index > lastIndex) {
        matchCount++;
        lastIndex = index;
      }
    }
    
    // Require ALL words from smaller name to match
    if (matchCount === smaller.length && smaller.length >= 2) {
      return true;
    }
  }
  
  // For names with 3+ words, require at least 70% overlap
  // This prevents matching on generic words like "downtown", "street", etc.
  const commonWords = words1.filter(word => words2.includes(word));
  const minWords = Math.min(words1.length, words2.length);
  
  // Require high overlap AND multiple matching words
  return commonWords.length >= 2 && (commonWords.length / minWords) >= 0.7;
}

// Export as ES6 module
export { normalizeString, isFuzzyMatch };